export default  {
  resetState: ({ commit }) => commit('resetState'),
  getItem ({ commit, dispatch }, options){
     dispatch('request', {type: 'match.item', options: options, next: function (response) {
          if (options.next) options.next(response)
     }}, {root: true} )
  },
  saveItem ({ commit, dispatch }, options){
     dispatch('request', {type: 'match.save', options: options, next: function (response) {
          if (options.next) options.next(response)
     }}, {root: true} )
  },
  getList ({ commit, dispatch }, options){
     dispatch('request', {type: 'match.list', options: options, next: function (response, count) {
          if (options.next) return options.next(response)
          commit('setList', response )
     }}, {root: true} )
  },
  setList ({ commit, dispatch }, options){
      commit('setList', {count:0, data: []} )
  },
  addQuestion({ commit, dispatch, state }, question) {
    if (state.selected.questions.filter(item => item.title == question.title ).length > 0) return false
    commit('addQuestion', question )
    return true
  },
  addAnswer ({ commit, dispatch, state }, answer){
      if (state.selected.answers.filter(item => item.question == answer.question && answer.owner.name == item.owner.name).length > 0) return false
      dispatch('request', {type: 'match.answer', options: {item: answer}, next: function (response, count) {
              
              commit('addAnswer', answer )
      }}, {root: true} )
  }
}